export default "__VITE_ASSET__D5uJI6xc__"